import { RadioDot } from "./radio-dot";
import { ConsultingBadge } from "./consulting-badge";
import IcLight from "@/assets/icons/ic-lighthub.svg";

interface ConsultingOption {
  id: string;
  title: string;
  badge: string;
  badgeType: "best-fit" | "high-rec";
  subtitle: string;
  description: string;
  message_solution: string;
}

export function ConsultingSection({
  options,
  selectedId,
  onSelect,
  hasMore,
}: {
  options: ConsultingOption[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  hasMore: boolean;
}) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <h2 className="text-xl font-bold leading-[24px] lg:leading-[28px] tracking-[-0.018em] lg:tracking-[-0.02em] text-[#000000]">
          컨설팅과 결합한 AX 컨설팅 추천
        </h2>
        <p className="text-sm leading-[20px] tracking-[-0.01em] text-[#000000]">
          에이전트 도입을 가속할 PwC 컨설팅 서비스. 필요한 항목을 함께 선택하세요.
        </p>
      </div>
      <div className="flex flex-col gap-3 min-[1120px]:gap-0 min-[1120px]:flex-row min-[1120px]:border min-[1120px]:border-[rgba(0,0,0,0.15)] min-[1120px]:rounded-[4px] min-[1120px]:overflow-hidden w-full">
        {options.map((option, idx) => {
          const isFirst = idx === 0;
          const isLast = idx === options.length - 1;
          const isSelected = selectedId === option.id;

          const selectedRadius =
            isFirst && isLast
              ? "min-[1120px]:rounded-[4px]"
              : isFirst
                ? "min-[1120px]:rounded-l-[4px] min-[1120px]:rounded-r-none"
                : isLast
                  ? "min-[1120px]:rounded-r-[4px] min-[1120px]:rounded-l-none"
                  : "min-[1120px]:rounded-none";

          return (
            <button
              key={option.id}
              type="button"
              onClick={() => onSelect(option.id)}
              className={`flex gap-4 p-4 min-[1120px]:p-6 w-full min-[1120px]:w-1/2 flex-1 text-left cursor-pointer rounded-[4px] min-[1120px]:rounded-none border min-[1120px]:border-0 ${
                isSelected
                  ? `border-[#202020] min-[1120px]:border-0 min-[1120px]:outline min-[1120px]:outline-1 min-[1120px]:outline-[#202020] min-[1120px]:-outline-offset-1 ${selectedRadius}`
                  : "border-[rgba(0,0,0,0.15)]"
              } ${idx > 0 ? "min-[1120px]:border-l min-[1120px]:border-[rgba(0,0,0,0.15)]" : ""}`}
            >
              <div className="flex items-start pt-2.5">
                <RadioDot checked={selectedId === option.id} />
              </div>
              <div className="flex flex-col gap-3 flex-1 min-w-0">
                <div className="flex justify-between gap-3 items-start">
                  <div className="flex-1 min-w-0 text-[24px] md:text-[32px] font-normal leading-[28px] md:leading-[40px] tracking-[-0.0183em] md:tracking-[-0.03em] text-[#000000] break-words">
                    {option.title}
                  </div>
                  <ConsultingBadge
                    type={option.badgeType}
                    label={option.badge}
                    className="flex-shrink-0 h-fit"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <span className="text-base font-semibold text-[#000000]">{option.subtitle}</span>
                  <p className="text-base text-[#000000] whitespace-pre-line">
                    {option.message_solution}
                  </p>

                  <p className="text-base text-[#000000] whitespace-pre-line">
                    {option.description}
                  </p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
      {hasMore && (
        <div className="flex items-start gap-3 border border-[rgba(0,0,0,0.15)] text-[#000000] rounded-[4px] p-4 mt-4">
          <img src={IcLight} alt="Warning" />
          <span>
            귀사의 비즈니스 혁신을 가속화할 추가적인 AX 실행 과제(CTA)가 준비되어 있습니다. 종합적인
            맞춤형 로드맵과 전체 리스트를 확인하시려면 PwC의 AX 컨설팅 전문가와 상의하세요.
          </span>
        </div>
      )}
    </div>
  );
}

export type { ConsultingOption };
